import { render, staticRenderFns } from "./contact-relation-form.vue?vue&type=template&id=cf863418&scoped=true&"
import script from "./contact-relation-form.ts?vue&type=script&lang=ts&"
export * from "./contact-relation-form.ts?vue&type=script&lang=ts&"
import style0 from "./contact-relation-form.scss?vue&type=style&index=0&id=cf863418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf863418",
  null
  
)

export default component.exports